import React, { useState, useEffect } from "react";
import {
  Box,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Button,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CategoryAutoComplete from "../../basic-information/productCategory/CategoryAutoComplete";
import BrandAutoComplete from "../../basic-information/brand/BrandAutoComplete";
import CompanyAutoComplete from "../../basic-information/company/CompanyAutoComplete";
import CountryAutocomplete from "../../basic-information/Countries/CountryAutocomplete";
import LicenceAutocomplete from "../../basic-information/Countries/LicenceAutocomplete";
import { UseProduct } from "./UseProduct";
import { useSnackbar } from "notistack";
import SearchCom from "./SearchCom";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function Level1(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { validateLvl1 } = UseProduct();
  const [level1, setLevel1] = React.useState({
    faName: "",
    enName: "",
    brandID: "",
    categoryID: "",
    countryID: "",
    licenceCountryID: "",
    companyID: "",
  });
  const { isSmall } = useBreakpoints();

  const [stateValidation, setStateValidation] = useState({
    faName: false,
    enName: false,
    brandID: false,
    categoryID: false,
    countryID: false,
    companyID: false,
  });

  useEffect(() => {
    if (props.fireGetData) {
      props.getDataFromLevel1(level1);
    }
  }, [props.fireGetData]);

  return (
    <Accordion
      expanded={props.expanded === "panel1"}
      style={{ margin: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography sx={{ width: "33%", flexShrink: 0 }}>
          مرحله اول : اطلاعات پایه
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <SearchCom
              state={level1}
              setState={setLevel1}
              stateValidation={stateValidation.faName}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              size="small"
              id="outlined-basic"
              value={level1.enName}
              error={stateValidation.enName}
              label="نام لاتین "
              variant="outlined"
              onChange={(event) => {
                setLevel1({
                  ...level1,
                  enName: event.target.value,
                });
              }}
              sx={{ width: "100%", input: { direction: "rtl" } }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <CategoryAutoComplete
              validation={stateValidation.categoryID}
              setter={setLevel1}
              lvl1State={level1}
            ></CategoryAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <BrandAutoComplete
              validation={stateValidation.brandID}
              setter={setLevel1}
              lvl1State={level1}
            ></BrandAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <CompanyAutoComplete
              validation={stateValidation.companyID}
              setter={setLevel1}
              lvl1State={level1}
            ></CompanyAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <CountryAutocomplete
              validation={stateValidation.countryID}
              setter={setLevel1}
              lvl1State={level1}
            ></CountryAutocomplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <LicenceAutocomplete
              setter={setLevel1}
              lvl1State={level1}
            ></LicenceAutocomplete>
          </Box>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button
            sx={{ width: "100px" }}
            variant="contained"
            size="small"
            color="secondary"
            onClick={() => {
              validateLvl1(level1, setStateValidation, (res) => {
                if (res == 200) {
                  enqueueSnackbar("مرحله اول با موفقیت تکمیل شد", {
                    variant: "success",
                    autoHideDuration: 2000,
                  });
                  props.setExpanded("panel2");
                } else {
                  return;
                }
              });
            }}
          >
            مرحله بعد
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
